import * as React from "react";
import { Input, Button, Row, Select, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { templatesStore } from "Pages/Project/Settings/Pages/Templates/Stores/TemplatesStore";

interface FileCreateFormProps extends WithTranslation, ModalComponentProps {
  onSubmit?: (o: API_TemplateUploadRequest) => void;
}

export const FileCreateForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<FileCreateFormProps> {
      componentDidMount() {
        (async () => {
          try {
            await templatesStore.fetch();
          } catch (error) {
            throw error;
          }
        })();
      }

      handleSubmit = (values) => {
        try {
          this.props.onSubmit(values);
          this.props.hideModal();
        } catch (error) {
          throw error;
        }
      };

      get templates() {
        return templatesStore.activeTemplates.map((template) => (
          <Select.Option key={`${template.id}`} value={template.id.toString()}>
            {template.name}
          </Select.Option>
        ));
      }

      render() {
        const { t } = this.props;

        return (
          <Form onFinish={this.handleSubmit}>
            <Form.Item
              label={t("Template")}
              name="templateId"
              rules={[{ required: true, message: t("Please select a template") }]}
            >
              <Select
                showSearch={{
                  filterOption: (input, option) =>
                    (option.props.children as string).toLowerCase().indexOf(input.toLowerCase()) >= 0,
                  optionFilterProp: "children",
                }}
              >
                {this.templates}
              </Select>
            </Form.Item>
            <Form.Item
              label={t("File name")}
              name="fileName"
              rules={[{ required: true, message: t("Please provide a file name") }]}
            >
              <Input autoFocus={true} />
            </Form.Item>

            <Row justify="end" className="mt-1">
              <Button loading={templatesStore.state === "LOADING"} type="primary" htmlType="submit">
                {t("Save")}
              </Button>
            </Row>
          </Form>
        );
      }
    }
  )
);
